import { EventEmitter } from 'events';

const eventEmitter = new EventEmitter();

export const WS_CONNECTION_EVENTS = {
  CONNECTED: 'ws:connected',
  DISCONNECTED: 'ws:disconnected',
  RECONNECTING: 'ws:reconnecting',
  RECONNECTED: 'ws:reconnected',
  ERROR: 'ws:error',
} as const;

export default eventEmitter;
